// src/api/team.js
import api from './client';

/**
 * Team Management API
 * Endpoints for managing organization team members
 */

/**
 * Get all team members in the organization
 */
export const getTeamMembers = async () => {
  try {
    const response = await api.get('/users/team/');
    // ⭐ FIX: Extract results from paginated response
    return response.data.results || response.data || [];
  } catch (error) {
    console.error('Error fetching team members:', error);
    throw error;
  }
};

/**
 * Add a new team member
 * @param {Object} userData - User data (username, email, first_name, last_name, password, role, phone)
 */
export const addTeamMember = async (userData) => {
  try {
    const response = await api.post('/users/team/', userData);
    return response.data;
  } catch (error) {
    console.error('Error adding team member:', error);
    throw error;
  }
};

/**
 * Update an existing team member
 * @param {string} userId - User ID
 * @param {Object} userData - Updated user data
 */
export const updateTeamMember = async (userId, userData) => {
  try {
    const response = await api.patch(`/users/team/${userId}/`, userData);
    return response.data;
  } catch (error) {
    console.error('Error updating team member:', error);
    throw error;
  }
};

/**
 * Delete (deactivate) a team member
 * @param {string} userId - User ID
 */
export const deleteTeamMember = async (userId) => {
  try {
    const response = await api.delete(`/users/team/${userId}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting team member:', error);
    throw error;
  }
};

export default {
  getTeamMembers,
  addTeamMember,
  updateTeamMember,
  deleteTeamMember,
};
